import React, { useContext } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { AuthContext } from 'contexts';
import ManageCardContextProvider, {
  ManageCardContext,
} from './ManageCardContext';
import Content from './Content';
import UpdateCardModal from './UpdateCardModal';
import UpdateJPMCModal from './UpdateJPMCModal';

export type ProductType = 'orgBilling' | 'appointmentDesk' | undefined;

export type CanManageType = {
  response: boolean;
  message?: string;
};

export type OverdueBalanceType = {
  response: boolean;
  message?: React.ReactNode;
};

export type ManageCardProps = {
  userId?: string;
  productType?: ProductType;
  canManageBilling: CanManageType;
  isSupraSubOverdue: OverdueBalanceType;
  onCardUpdateSuccess?: () => void;
  isBillingPage?: boolean;
  stripePk: string;
};

const defaultIsSupraSubOverdue: OverdueBalanceType = {
  response: false,
};

const defaultCanManageBilling: CanManageType = {
  response: true,
};

const ModalSwitcher: React.FC = () => {
  const { showJPMC } = useContext(ManageCardContext);
  return showJPMC ? <UpdateJPMCModal /> : <UpdateCardModal />;
};

const ManageCard: React.FC<ManageCardProps> = ({
  productType = 'orgBilling',
  userId,
  canManageBilling = defaultCanManageBilling,
  isSupraSubOverdue = defaultIsSupraSubOverdue,
  onCardUpdateSuccess,
  isBillingPage = true,
  stripePk,
}) => {
  const stripePromise = React.useMemo(() => loadStripe(stripePk), [stripePk]);
  const { auth } = useContext(AuthContext);

  return (
    <Elements stripe={stripePromise}>
      <ManageCardContextProvider
        userId={userId}
        productType={productType}
        canManageBilling={canManageBilling}
        isSupraSubOverdue={isSupraSubOverdue}
        onCardUpdateSuccess={onCardUpdateSuccess}
        isBillingPage={isBillingPage}
        orgId={auth.org.id}
        billingCustomerNumber={auth.billingCustomerNumber}
      >
        <Content />
        <ModalSwitcher />
      </ManageCardContextProvider>
    </Elements>
  );
};

export default ManageCard;
